module.exports = __webpack_public_path__ + "img/gallery.eb3b2877.svg";